import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { Button } from 'antd';

export function BtnGuide(props){
  return(
    <Button
      onClick={props.onClick}
      icon="play-circle-o"
      id="btn-guide"
      style={props.style}
      >Guide
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/components/Buttons/BtnGuide.js